//通用
import { Data as AuthContent } from '../authentication/index'
import { Data as ChangeLogContent } from '../changelog/index'



import Introduce from './1_introduce.json'
import { Data as AccountContent } from './api/account/index'
import { Data as WalletContent } from './api/wallet/index'
import { Data as TradeOrderContent } from './api/trade/index'
import { Data as MarketContent } from './api/market/index'
import { Data as BasicContent } from './api/basic/index'
import { List as SocketContent } from './websocket/index'


const ROOT_MODULE = "zh-tw/spot"
import { Data as QandAContent } from '../q&a/index'
const QandA = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/q&a`,
  "name": "常見問題",
  "content": QandAContent
}

export const Socket = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/socket`,
  "name": "Socket 文檔",
  "children": SocketContent
}


const ChangeLog = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/changelog`,
  "name": "變更日誌",
  "content": ChangeLogContent
}
const TradeOrder = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/trade-api.html`,
  "name": "交易接口",
  "content": TradeOrderContent
}
const Authentication = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/authentication.html`,
  "name": "簽名認證",
  "content": AuthContent
}
const Basic = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/base-info.html`,
  "name": "基礎信息",
  "content": BasicContent
}
const Account = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/account-api.html`,
  "name": "賬戶資產",
  "content": AccountContent
}
const Wallet = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/wallet-api.html`,
  "name": "錢包充提",
  "content": WalletContent
}
const Market = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/market-api.html`,
  "name": "行情數據",
  "content": MarketContent
}


export const spotConfig = [
  Introduce,
  ChangeLog,
  QandA,
  Basic,
  Authentication,
  Market,
  Wallet,
  Account,
  TradeOrder,
  // Other,
  Socket,
]


// WEBPACK FOOTER //
// ./src/config/zh-tw/spot/index.js